/* src/app/shared-components/shared-with/shared-with.component.scss */
.user-info {
  display: inline-block;
}
.user-info .user-thumb {
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  margin-right: 0.25rem;
}
.user-info .user-owner {
  margin-left: 0.5rem;
}
.shared-title {
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 300;
  margin-bottom: 0;
  font-family: EYInterstate;
  color: #72727f;
  margin-bottom: 0.5rem;
}
.big .user-info .user-thumb {
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 0.5rem;
}
/*# sourceMappingURL=shared-with.component.css.map */
